module.exports = __webpack_public_path__ + "static/media/Welcome---Slide-1-B2b-V_4.b0a1eb6e.png";